// The index route `/`: sends the user to home (home-path.ts). Login, the password reset and the account
// create all finish on `/`, so they land here too.
import { Navigate, useLocation } from 'react-router-dom';
import { useHomePath } from '@/shared/lib/home-path';

export function HomeRedirect() {
  return <Navigate to={useHomePath()} replace />;
}

/** `/today`: the old worklist route redirects home (owner, 21 Oct). The query and hash ride along, so a link carrying
 *  a switch (`?ef=…`, `?x=…`) keeps it. */
export function TodayRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: useHomePath(), search, hash }} replace />;
}
